export const EMMA_MARKETING_WEBSITE_URL_FR = 'https://emma.ca/assurance-vie';
export const EMMA_MARKETING_WEBSITE_URL_EN = 'https://emma.ca';
export const EMMA_SUPPORT_URL_FR = 'https://emma.ca/support';
export const EMMA_SUPPORT_URL_EN = 'https://emma.ca/en/support';
export const EMMA_CLIENT_SUPPORT_URL_FR = 'https://emma.ca/support/client';
export const EMMA_CLIENT_SUPPORT_URL_EN = 'https://emma.ca/en/support/client';
export const PRO_SIGN_UP_PAGE_FR = 'https://emma.ca/pro';
export const PRO_SIGN_UP_PAGE_EN = 'https://emma.ca/en/pro';
export const EMMA_DEFAULT_EMAIL = 'bonjour@emma.ca';
export const EMMA_SUPPORT_EMAIL = 'support@emma.ca';
